import {CSSProperties} from '../../../styleSheet';
import {BaseFlexDirectionProps} from '../types';

export const buildFlexDirectionStyle = ({
  direction,
  horizontal,
  vertical,
}: BaseFlexDirectionProps = {}): CSSProperties => {
  return {
    ...(direction === 'Horizontal' || horizontal ? {flexDirection: 'row'} : {}),
    ...(direction === 'Vertical' || vertical ? {flexDirection: 'column'} : {}),
  };
};
